import { render } from "./ModalTransaction.vue?vue&type=template&id=5cde332b&ts=true"
import script from "./ModalTransaction.vue?vue&type=script&lang=ts"
export * from "./ModalTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adminhost/web/cr55perjuangan.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__